import styled from "@emotion/styled";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DesignToken, Switch, Text } from "@livechat/design-system-react-components";

import { AgentActions } from "store/entities/agents";
import { selectTheme } from "store/features/app";
import { withVar } from "themes/helpers";

import { NavigationOption } from "./styles";

export const NavigationThemeSwitcher: FC = () => {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);

  const handleChangeTheme = (): void => {
    dispatch(AgentActions.changeTheme({ theme: theme === "light" ? "dark" : "light" }));
  };

  return (
    <NavigationOption>
      <Text size="sm" customColor={withVar(DesignToken.ContentBasicPrimary)}>
        Dark mode
      </Text>
      <DarkModeSwitch on={theme === "dark"} onChange={handleChangeTheme} size="compact" />
    </NavigationOption>
  );
};

const DarkModeSwitch = styled(Switch)`
  margin-left: auto;
`;
